<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue';
import RobotFinderCatalogue from '@/components/robotFinder/RobotFinderCatalogue.vue';
import RobotFinderBuilder from '@/components/robotFinder/RobotFinderBuilder.vue';
import RobotFinderSmartSuggestions from '@/components/robotFinder/RobotFinderSmartSuggestions.vue';
import { getLatestRobotModules } from '@/helpers/RobotHelper';
import { ModuleFolderMapping } from '@/models/RobotFinder';

const tab = ref(null);
const latestRobotModules: Ref<ModuleFolderMapping> = ref({});

onMounted(async () => {
  const moduleFolderMapping = await getLatestRobotModules();
  if (moduleFolderMapping !== undefined) {
    latestRobotModules.value = moduleFolderMapping;
  } else {
    console.error("Couldn't load modules");
  }
});
</script>

<template>
  <v-container fluid>
    <v-tabs v-model="tab" color="dusk-blue" align-tabs="center" grow>
      <v-tab value="build-your-own-robco">
        <v-icon start>mdi-robot-industrial</v-icon>
        {{ $gettext('Build Your Own RobCo') }}
      </v-tab>
      <v-tab value="smart-suggestions">
        <v-icon start>mdi-lightbulb-on-10</v-icon>
        {{ $gettext('Smart Suggestions') }}
      </v-tab>
      <v-tab value="robco-catalog">
        <v-icon start>mdi-book-open-variant</v-icon>
        {{ $gettext('Robot Catalog') }}
      </v-tab>
    </v-tabs>
    <v-window v-model="tab" class="mt-4">
      <v-window-item value="build-your-own-robco">
        <robot-finder-builder
          v-show="tab === 'build-your-own-robco'"
          :latestRobotModules="latestRobotModules"
        />
      </v-window-item>
      <v-window-item value="smart-suggestions">
        <robot-finder-smart-suggestions
          v-show="tab === 'smart-suggestions'"
          :latestRobotModules="latestRobotModules"
        />
      </v-window-item>
      <v-window-item value="robco-catalog">
        <robot-finder-catalogue
          v-show="tab === 'robco-catalog'"
          :latestRobotModules="latestRobotModules"
        />
      </v-window-item>
    </v-window>
  </v-container>
</template>
